import Cookie from "js-cookie";
import store from "@/store";

export const ADMIN_LOGIN_MESSAGE =
    "Admins may not log into the app directly. Please use the admin panel instead.";

export function rejectAdminLogin(user) {
    if (!user || user.type !== "admin") {
        return false;
    }

    Cookie.remove(process.env.VUE_APP_AUTH_COOKIE_NAME);
    delete window.axios.defaults.headers.common["Authorization"];
    store.dispatch("resetState");

    return true;
}
